import React from "react";
import { Component } from "react";
import { RequestHeaders } from "../../../common/header-logo/request-header.component";
import { ACCESS_MODULE, MATRIX_INDICATOR } from "../../../../utils/rbac-constants.utils";
import { validateAccessModule } from "../../../../utils/helpers.utils";
import { manageUserActions } from "../../../../store/external/manage-user/manage-user.reducer";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import DetailContainer from "../../../common/Layout/details/DetailsLayout.component";
import { Selected_Index } from '../../../../constants/external-constants';
import "../finance.css";
import RateCardTable from "./rate-card-table.component";
import RateCardUploadView from "../rate-card-upload/rate-card-upload-view";

class RateCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: Selected_Index.i_Zero,
            contentIndex:  Selected_Index.i_Zero        
        }
    }
   
    handleSelectedIndex = (index) =>{
        this.setState({contentIndex: index})      
    }
    render() {
       
        let isReadOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.HRManagementDashboardR])
        let isReadAndExtractOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.HRManagementDashboardRE])
        let isReadAndWrite = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.HRManagementDashboardRW])
        
        const { contentIndex } = this.state
        return(
            <div className="rate-card-container invoice-wrapper-container inventory-report-component" >
                <RequestHeaders headerTitle={'RateCard'} />                
                <div className="request-table data-table fit-width">
                  <DetailContainer
                     renderTabContent={this.handleSelectedIndex}
                     urlIndex={this.state.activeTab}
                     listTab={ [
                         {
                             "id": Selected_Index.i_Zero,
                             "label": "Rate Card",
                             "hidden": false
                         },
                         {
                             "id": Selected_Index.i_One,
                             "label": "Rate Card Upload",
                             "hidden": false,
                             "disable": false
                         },
                        
                     ]}
                  >
                    
                  {contentIndex === Selected_Index.i_Zero && <RateCardTable />}
                  {contentIndex === Selected_Index.i_One && <RateCardUploadView />}

                </DetailContainer>
                </div>                
            </div>
        )
    }
}

export default RateCard;